// Moyens de paiement — opérateurs Mobile Money & carte (Côte d'Ivoire / UEMOA)
import { Banknote, CreditCard, Smartphone, Wallet } from "lucide-react";

export const PAYMENT_OPERATORS = [
  { id: "orange_money", label: "Orange Money", short: "Orange", color: "#FF7900", text: "#000000", icon: Smartphone },
  { id: "wave", label: "Wave", short: "Wave", color: "#1DC3F0", text: "#000000", icon: Smartphone },
  { id: "mtn_momo", label: "MTN MoMo", short: "MTN", color: "#FFCC00", text: "#000000", icon: Smartphone },
  { id: "moov_money", label: "Moov Money", short: "Moov", color: "#0066B3", text: "#FFFFFF", icon: Smartphone },
  { id: "djamo", label: "Djamo", short: "Djamo", color: "#5B3DF5", text: "#FFFFFF", icon: Wallet },
  { id: "bank_card", label: "Carte bancaire", short: "Carte", color: "#374151", text: "#FFFFFF", icon: CreditCard },
  { id: "other", label: "Autre", short: "Autre", color: "#6B7280", text: "#FFFFFF", icon: Wallet },
];

export const ALL_OPERATOR_IDS = PAYMENT_OPERATORS.map((o) => o.id);

export const getOperator = (id) => PAYMENT_OPERATORS.find((o) => o.id === id);

// Operators enabled for the boutique (null/undefined = all)
export const enabledOperators = (settings) => {
  const ids = settings?.payment_operators;
  if (!Array.isArray(ids) || ids.length === 0) return PAYMENT_OPERATORS;
  return PAYMENT_OPERATORS.filter((o) => ids.includes(o.id));
};

// Human label for an invoice payment ("Espèces", "Orange Money", "Autre · Push")
export const paymentLabel = (invoice) => {
  if (!invoice) return "";
  if (invoice.payment_method === "cash") return "Espèces";
  if (invoice.payment_method === "card" || invoice.payment_method === "mobile") {
    const op = getOperator(invoice.payment_operator);
    if (!op) return invoice.payment_method === "mobile" ? "Mobile Money" : "Carte / Mobile Money";
    return op.id === "other" && invoice.payment_operator_label ? `Autre · ${invoice.payment_operator_label}` : op.label;
  }
  return "Mixte";
};

export const PAYMENT_METHODS = [
  { id: "cash", icon: Banknote, label: "Espèces", color: "#111111" },
  { id: "card", icon: CreditCard, label: "Carte / Mobile Money", color: "#22C55E" },
];
